import {useParams} from 'react-router-dom';

function useGetGuestId() {
  const {id} = useParams<{id: string}>();

  return id;
}

export {useGetGuestId};
